<template lang="pug">
.supercharged-entertainment-container
  .confirm(v-if="isClaimed")
    .confirm__container
      re-toast-alert(v-if="errorMessage" type="danger") {{ errorMessage }}
      h3.h3.confirm__caption
        | Thank you, gift card details has been sent to the following email address {{ email }}.
      p.text-simple.confirm__text.confirm__text_mod
        | If you have not received an email please click on the  
        v-button.btn-link.text-simple__link(@click="resend" :loading="isResending" no-default-class) resend
        |  link.
  .claim-card(v-else)
    .claim-card__container
      h2.h2.claim-card__caption Claim Gift Card
      re-toast-alert.m-b-20(v-if="errorMessage" type="danger") {{ errorMessage }}
      form(@submit.prevent="claim")
        div
          label Email Address
          input(v-model="email" type="text")
        v-button.site_button.site_button_inverse.claim-card__submit(@click.prevent="claim" :loading="isClaiming" :disabled="$v.email.$invalid" no-default-class)
          span Claim

  substrate(v-if="showResentModal" @close="showResentModal = false")
    p The gift card details has been resent to the following email address {{ email }}.

</template>

<script>
import axios from 'axios'
import {getQS} from 'utils/vue/lib/utils'
import { required, email } from 'vuelidate/lib/validators'
import PagesMixin from '../../components/_mixins/pages'
import ConfigMixin from '../../components/_mixins/config'
import { getFirstErrorMessage } from '~/lib/axios'

export default {
  name: 'page-claim-gift-card',
  settings: 'page.claim-giftcard',
  translations: 'page.claim-giftcard',
  mixins: [
    PagesMixin,
    ConfigMixin,
  ],

  data: () => ({
    email: null,
    isClaiming: false,
    isClaimed: false,
    errorMessage: null,
    isResending: false,
    showResentModal: false,
  }),

  validations: {
    email: {
      required,
      email,
    },
  },

  methods: {
    async claim() {
      try {
        const token = this.$route.query.token || _.get(getQS(), 'token')
        this.isClaiming = true
        await axios.post(`${this.config.apiUri}/customer/giftcard/${token}/claim/recipient`, {
          email: this.email,
        })
        this.isClaimed = true
        this.errorMessage = null
      } catch (e) {
        this.errorMessage = getFirstErrorMessage(e)
      } finally {
        this.isClaiming = false
      }
    },

    async resend() {
      try {
        const token = this.$route.query.token || _.get(getQS(), 'token')
        this.isResending = true
        await axios.post(`${this.config.apiUri}/customer/giftcard/${token}/clubspeed/send-cvv`)
        this.showResentModal = true
        this.errorMessage = null
      } catch (e) {
        this.errorMessage = getFirstErrorMessage(e)
      } finally {
        this.isResending = false
      }
    },
  },
}
</script>

<style lang="scss">
.supercharged-entertainment-container {
  .claim-card,
  .confirm {
    background: none;
  }
  .btn-link {
    border: 0;
    padding: 0;
  }
}
</style>
